import {downloadVttResourceUrl, listVttResources, removeVttResource, uploadVttResource} from './vttResourcesApi';
import {chapterApiLanguage} from '../../utils/chapterLanguage';

export const listChapters = async (identifier) => {
  const response = await listVttResources(identifier, 'chapter');
  if (!response.ok) throw new Error('record_chapters_error');
  return response.json();
};

export const downloadChapterUrl = (identifier, language) => downloadVttResourceUrl(identifier, 'chapter', language);

const saveChapters = async (identifier, chapters = {}) => {
  for (const [language, file] of Object.entries(chapters)) {
    if (!['fi', 'en', 'sv'].includes(language) || file === undefined) continue;
    let response;
    if (file === null) {
      response = await removeVttResource(identifier, 'chapter', language);
    } else {
      const content = await file.text();
      response = await uploadVttResource(identifier, 'chapter', JSON.stringify({language: chapterApiLanguage(language), title: file.name, vttContent: content}), {'content-type': 'application/json'});
    }
    if (!response.ok) throw new Error('record_chapters_error');
  }
};

export default saveChapters;